import React, { useCallback, useState } from "react"

import useAppHotkey from "@hooks/useAppHotkey"

import { PreviewModeContext } from "./PreviewMode.context"

export const PreviewModeProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
    const [isPreviewModeEnabled, setisPreviewModeEnabled] = useState(false)

    const togglePreviewMode = useCallback(() => {
        setisPreviewModeEnabled((prev) => !prev)
    }, [])

    useAppHotkey(
        "space",
        (event) => {
            event.preventDefault()
            togglePreviewMode()
        },
        { preventDefault: true },
        [togglePreviewMode],
    )

    return (
        <PreviewModeContext.Provider
            value={{
                isPreviewModeEnabled,
            }}
        >
            {children}
        </PreviewModeContext.Provider>
    )
}
